import React from "react";
import BaseCard from "./BaseCard";
import InputTypesEnum from "../../../../Enums/InputTypesEnum";
import CardHeader from "./CardHeader";
import DataTable from "../../../../Elements/DataTable/DataTableFigma";
import FieldTypesEnum from '../../../../Enums/FieldTypesEnum';

class CostSplitCard extends BaseCard {
  render() {
    const { Tier } = this.props;

    return (
      <div className='card'>
        <CardHeader
          bodyactive={this.state.bodyactive}
          changeBodyStatus={this.changeBodyStatus}
          sectionNumber={'10'}
          HeaderText={'COST SPLIT'}
          disabled={!this.props.UserCanMarkup}
        />
        {this.state.bodyactive && this.props.UserCanMarkup ? (
          <div>
            <DataTable
              type={{
                FieldsToShowInDataTable: this.FieldsToShowInDataTable,
                NameOfTheIdField: () => 'TierId',
                FieldsToShowInListTable: [],
                MoneyFields: this.MoneyFields,
                Currency: this.Currency,
              }}
              renderInputFieldFunction={this.renderInputField}
              DataTableType='Header'
              smallDataTable={true}
              thereIsNoSuchRowMessageCheck={false}
            />
            <DataTable
              type={{
                FieldsToShowInDataTable: this.FieldsToShowInDataTableOwningOfficeTotalRevenue,
                NameOfTheIdField: () => 'TierId',
                FieldsToShowInListTable: [],
                MoneyFields: this.MoneyFields,
                Currency: this.Currency,
              }}
              itemList={Tier}
              renderInputFieldFunction={this.renderInputField}
              DataTableType='Body'
              smallDataTable={true}
            />
            <DataTable
              type={{
                FieldsToShowInDataTable: this.FieldsToShowInDataTableOwningOfficeTotalCost,
                NameOfTheIdField: () => 'TierId',
                FieldsToShowInListTable: [],
                MoneyFields: this.MoneyFields,
                Currency: this.Currency,
              }}
              itemList={Tier}
              renderInputFieldFunction={this.renderInputField}
              DataTableType='Body'
              smallDataTable={true}
            />
            <DataTable
              type={{
                FieldsToShowInDataTable: this.FieldsToShowInDataTableOwningOfficeTotalCostDeferdedCost,
                NameOfTheIdField: () => 'TierId',
                FieldsToShowInListTable: [],
                MoneyFields: this.MoneyFields,
                Currency: this.Currency,
              }}
              itemList={Tier}
              renderInputFieldFunction={this.renderInputField}
              DataTableType='Body'
              smallDataTable={true}
            />
            <DataTable
              type={{
                FieldsToShowInDataTable: this.FieldsToShowInDataTableOwningOfficeTotalCostFieldworkCost,
                NameOfTheIdField: () => 'TierId',
                FieldsToShowInListTable: [],
                MoneyFields: this.MoneyFields,
                Currency: this.Currency,
              }}
              itemList={Tier}
              renderInputFieldFunction={this.renderInputField}
              DataTableType='Body'
              smallDataTable={true}
            />
            <DataTable
              type={{
                FieldsToShowInDataTable: this.FieldsToShowInDataTableFieldworkOfficeCost,
                NameOfTheIdField: () => 'TierId',
                FieldsToShowInListTable: [],
                MoneyFields: this.MoneyFields,
                Currency: this.Currency,
              }}
              itemList={Tier}
              renderInputFieldFunction={this.renderInputField}
              DataTableType='Body'
              smallDataTable={true}
            />
            <DataTable
              type={{
                FieldsToShowInDataTable: this.FieldsToShowInDataTableFieldworkOfficeNetRevenue,
                NameOfTheIdField: () => 'TierId',
                FieldsToShowInListTable: [],
                MoneyFields: this.MoneyFields,
                Currency: this.Currency,
              }}
              itemList={Tier}
              renderInputFieldFunction={this.renderInputField}
              DataTableType='Body'
              smallDataTable={true}
            />
            <DataTable
              type={{
                FieldsToShowInDataTable: this.FieldsToShowInDataTableFieldworkOwningOfficeNetRevenue,
                NameOfTheIdField: () => 'TierId',
                FieldsToShowInListTable: [],
                MoneyFields: this.MoneyFields,
                Currency: this.Currency,
              }}
              itemList={Tier}
              renderInputFieldFunction={this.renderInputField}
              DataTableType='Body'
              smallDataTable={true}
            />
          </div>
        ) : null}
      </div>
    );
  }
  FieldsToShowInDataTable() {
    return [
      { label: ' ', tableminWidth: '175px' },
      { label: ' ', tableminWidth: '125px' },
      { label: ' ', tableminWidth: '200px' },
      { label: 'Per cycle', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: 'Annually', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: '% of cost', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: '% of revenue', tableminWidth: '125px', headerPosition: 'header-text-right' },
    ];
  }

  FieldsToShowInDataTableOwningOfficeTotalRevenue() {
    return [
      { label: 'Owning Office Total Revenue', data: '', type: FieldTypesEnum.JustLabel, tableminWidth: '175px' },
      { data: '', type: FieldTypesEnum.EmptySpace, tableminWidth: '125px' },
      { data: '', type: FieldTypesEnum.EmptySpace, tableminWidth: '200px' },
      { data: 'RevenuePerCycle', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { data: 'RevenueAnnually', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { data: '', type: FieldTypesEnum.EmptySpace, tableminWidth: '125px', headerPosition: 'header-text-right' },

      {
        label: '100.00%',
        data: '',
        type: FieldTypesEnum.JustLabel,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
    ];
  }
  FieldsToShowInDataTableOwningOfficeTotalCost() {
    return [
      { label: 'Owning Office Total Cost', data: '', type: FieldTypesEnum.JustLabel, tableminWidth: '175px' },
      { data: '', type: FieldTypesEnum.EmptySpace, tableminWidth: '125px' },
      { data: '', type: FieldTypesEnum.EmptySpace, tableminWidth: '200px' },
      { data: 'CostPerCycle', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { data: 'CostAnnually', tableminWidth: '125px', headerPosition: 'header-text-right' },
      {
        label: '100.00%',
        data: '',
        type: FieldTypesEnum.JustLabel,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      {
        data: 'CostAnnuallyMarkedUpRevenueTotalPct',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
    ];
  }
  FieldsToShowInDataTableOwningOfficeTotalCostDeferdedCost() {
    return [
      { data: '', type: FieldTypesEnum.EmptySpace, tableminWidth: '175px' },
      { label: 'Deferred Cost', data: '', type: FieldTypesEnum.JustLabel, tableminWidth: '125px' },
      { data: '', type: FieldTypesEnum.EmptySpace, tableminWidth: '200px' },
      { data: 'DeferredCostPerCycle', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { data: 'DeferredCostAnnually', tableminWidth: '125px', headerPosition: 'header-text-right' },
      {
        data: 'DeferredCostAnnuallyPct',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      {
        data: 'DeferredCostAnnuallyMarkedUpRevenueTotalPct',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
    ];
  }
  FieldsToShowInDataTableOwningOfficeTotalCostFieldworkCost() {
    return [
      { data: '', type: FieldTypesEnum.EmptySpace, tableminWidth: '175px' },
      { label: 'Fieldwork Cost', data: '', type: FieldTypesEnum.JustLabel, tableminWidth: '125px' },
      { data: '', type: FieldTypesEnum.EmptySpace, tableminWidth: '200px' },
      { data: 'ClientFeePerCycleTotal', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { data: 'ClientRevenueTotal', tableminWidth: '125px', headerPosition: 'header-text-right' },
      {
        data: 'ClientRevenueTotalCostAnnually',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      {
        data: 'ClientRevenueTotalMarkedUpRevenueTotalPct',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
    ];
  }
  FieldsToShowInDataTableFieldworkOfficeCost() {
    return [
      { data: '', type: FieldTypesEnum.EmptySpace, tableminWidth: '175px' },
      { data: '', type: FieldTypesEnum.EmptySpace, tableminWidth: '125px' },
      { label: 'Fieldwork Office Cost', data: '', type: FieldTypesEnum.JustLabel, tableminWidth: '200px' },
      {
        data: 'FieldworkOfficeCostPerCycle',
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      { data: 'FieldworkOfficeCostAnnually', tableminWidth: '125px', headerPosition: 'header-text-right' },
      {
        data: 'FieldworkOfficeCostAnnuallyCostAnnuallyPtc',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      {
        data: 'FieldworkOfficeMarkedUpRevenueTotalPtc',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
    ];
  }
  FieldsToShowInDataTableFieldworkOfficeNetRevenue() {
    return [
      { data: '', type: FieldTypesEnum.EmptySpace, tableminWidth: '175px' },
      { data: '', type: FieldTypesEnum.EmptySpace, tableminWidth: '125px' },
      { label: 'Fieldwork Office Net Revenue', data: '', type: FieldTypesEnum.JustLabel, tableminWidth: '200px' },
      { data: 'FieldworkOfficeNetRevenuePerCycle', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { data: 'FieldworkOfficeNetRevenueAnnually', tableminWidth: '125px', headerPosition: 'header-text-right' },
      {
        data: 'FieldworkOfficeNetRevenueOfCost',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      {
        data: 'FieldworkOfficeNetRevenueOfRevenue',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
    ];
  }
  FieldsToShowInDataTableFieldworkOwningOfficeNetRevenue() {
    return [
      { label: 'Owning Office Net Revenue', data: '', type: FieldTypesEnum.JustLabel, tableminWidth: '175px' },
      { data: '', type: FieldTypesEnum.EmptySpace, tableminWidth: '125px' },
      { data: '', type: FieldTypesEnum.EmptySpace, tableminWidth: '200px' },
      { data: 'OwningOfficeNetRevenuePerCycle', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { data: 'OwningOfficeNetRevenueAnnually', tableminWidth: '125px', headerPosition: 'header-text-right' },
      {
        label: ' ',
        data: '',
        type: FieldTypesEnum.EmptySpace,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      {
        data: 'OwningOfficeNetRevenueOfRevenue',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
    ];
  }
}

export default CostSplitCard;
